import { makeStyles } from "tss-react/mui";
const useStyles = makeStyles()(({ px, tokens })=>({
        root: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            padding: px(tokens.spacing[4]),
            fontSize: tokens.typography.variant.body2.fontSize,
            cursor: 'pointer',
            '&:hover svg, &:hover p, &:hover span': {
                color: `${tokens.colors.original.brand.primary}`
            }
        }
    }));
export { useStyles };
